import { Component, OnInit } from "@angular/core";
import { FirebaseService, User } from "src/app/core";
import { Router } from '@angular/router';

@Component({
  selector: "ll-welcome-user",
  templateUrl: "./welcome-user.component.html",
  styleUrls: ["./welcome-user.component.scss"]
})
export class WelcomeUserComponent implements OnInit {
  constructor(public fb: FirebaseService, private router: Router) {}

  ngOnInit(): void {}
  get name(): string {
    return this.fb.user == null || this.fb.user.currentUser == null
      ? ""
      : this.fb.user.currentUser.name.includes(" ")
      ? this.fb.user.currentUser.name.split(" ")[0]
      : this.fb.user.currentUser.name;
  }


  goToEditUser(){
    console.log("EDIT USER");
    this.edit();

  }

  edit() {
    this.fb.user.editingUser(this.fb.user.currentUser);
    this.router.navigate(["/", "admin", "accounts", "admin-form"]);
  }
}
